import React from 'react';
import { DeliveryIssueRow } from '../callCenterDeliveryIssuesTypes';
import { PriorityBadge, StatusBadge, ViewButton, IssueCard } from '../../shared';
import sharedStyles from '../../shared/IssueTable.module.css';
import styles from './DeliveryIssuesTable.module.css';

interface DeliveryIssuesTableProps {
  rows: DeliveryIssueRow[];
  onView?: (id: string) => void;
}

export const DeliveryIssuesTable: React.FC<DeliveryIssuesTableProps> = ({ rows, onView }) => {
  return (
    <IssueCard title="Delivery Issues">
      <div className={sharedStyles.tableWrap}>
        <table className={sharedStyles.table}>
          <thead>
            <tr>
              <th>TICKET ID</th>
              <th>DELIVERY ID</th>
              <th>DRIVER</th>
              <th>FAILURE REASON</th>
              <th>PRIORITY</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={sharedStyles.ticketId}>{row.ticketId}</td>
                <td>{row.deliveryId}</td>
                <td className={sharedStyles.bold}>{row.driver}</td>
                <td className={styles.failureReason}>{row.failureReason}</td>
                <td>
                  <PriorityBadge priority={row.priority} />
                </td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>
                  <ViewButton onClick={() => onView?.(row.id)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </IssueCard>
  );
};
